<div class="map-container">
  <div class="project-list">
    <p>项目列表</p>
    <li *ngFor="let item of products">
      {{ item }}
    </li>
  </div>
  <div id="map"></div>
</div>
